import { useContext, useMemo } from 'react';

import { FilteredHeatMapDataContext } from './FilteredHeatMapDataProvider';

/**
 * useFilterOptions
 *
 * Simple hook to expose the filter options as held in the FilteredMapDataContext
 */
export const useHeatMapFilterOptions = () => {
  const filteredMapData = useContext(FilteredHeatMapDataContext);

  if (!filteredMapData) {
    throw new Error(
      'useMapData hook it being used outside of the MapDataProvider',
    );
  }

  const {
    updateFilterOptions,
    filterOptions,
    resetFilterOptions,
    filterConfig,
    setRangeType,
    rangeType,
    setFilterTypeSex,
    filterTypeSex,
    setFilterTypeStatus,
    filterTypeStatus,
    filteredCountryMetaData,
    filteredCountryCount,
  } = useMemo(
    () => ({
      updateFilterOptions: filteredMapData.updateFilterOptions,
      filterOptions: filteredMapData.filterOptions,
      resetFilterOptions: filteredMapData.resetFilterOptions,
      filterConfig: filteredMapData.filterConfig,
      setRangeType: filteredMapData.setRangeType,
      rangeType: filteredMapData.rangeType,
      setFilterTypeSex: filteredMapData.setFilterTypeSex,
      filterTypeSex: filteredMapData.filterTypeSex,
      setFilterTypeStatus: filteredMapData.setFilterTypeStatus,
      filterTypeStatus: filteredMapData.filterTypeStatus,
      filteredCountryMetaData: filteredMapData.filteredCountryMetaData,
      filteredCountryCount: filteredMapData.filteredCountryCount,
    }),
    [
      filteredMapData.updateFilterOptions,
      filteredMapData.filterOptions,
      filteredMapData.resetFilterOptions,
      filteredMapData.filterConfig,
      filteredMapData.setRangeType,
      filteredMapData.rangeType,
      filteredMapData.setFilterTypeSex,
      filteredMapData.filterTypeSex,
      filteredMapData.setFilterTypeStatus,
      filteredMapData.filterTypeStatus,
      filteredMapData.filteredCountryMetaData,
      filteredMapData.filteredCountryCount,
    ],
  );

  return {
    updateFilterOptions,
    filterOptions,
    resetFilterOptions,
    filterConfig,
    setRangeType,
    rangeType,
    setFilterTypeSex,
    filterTypeSex,
    setFilterTypeStatus,
    filterTypeStatus,
    filteredCountryMetaData,
    filteredCountryCount,
  };
};
